
import { JWayIcon } from "../../../common/assets/JWayIcons";
import ButtonSmallIcon from "../../../common/components/atom/ButtonSmallIcon/ButtonSmallIcon";
import HeaderTitleContent from "../../../common/components/atom/HeaderTitleContent/HeaderTitleContent";
import PageContent from "../../../common/components/atom/PageContent/PageContent";
import SectionTitle from "../../../common/components/atom/SectionTitle/SectionTitle";
import TextBox from "../../../common/components/molecule/TextBox/TextBox";
import SingleChargePoint from "../../../features/stations/components/SingleChargePoint";
import { SingleStation } from "../../../features/stations/components/SingleStation";
import { SingleChargingSessionPageDrawer } from "../../ChargingSessionPage/SingleChargingSessionPage/SingleChargingSessionPage";
import { EditConnectorPageDrawer } from "../EditConnectorPage/EditConnectorPage";
import { SingleConnectorModal } from "../SingleConnectorPage/SingleConnectorPage";

export default function SingleStationPage() {

  return (
    <PageContent>
      <HeaderTitleContent
        withGoBackBtn
        SubTitleRender={<SingleStation.CountryCity />}
        rightContainer={<SingleStation.ActionBtn />}
        spaceBetween
      >
        <SingleStation.Name />
      </HeaderTitleContent>
 
  
      <div
        style={{ display: "flex", flexWrap: "wrap", gap: 10, margin: "15px 0" }}
      >
        <ButtonSmallIcon iconType="time" label="Créée le ">
          <SingleStation.StationInfo info="station_created_at" />
        </ButtonSmallIcon>
        <ButtonSmallIcon iconType="ship" label="Device Id: ">
          <SingleStation.StationInfo info="station_hardware_id" />
        </ButtonSmallIcon>
        {/*
        <ButtonSmallIcon label="Statut: ">
          <SingleStation.StationInfo info="station_status" styled />
        </ButtonSmallIcon>
        */}
        <ButtonSmallIcon label="Slug: ">
          <SingleStation.StationInfo info="station_slug" styled />
        </ButtonSmallIcon>
        <SingleStation.StationInfo
          info="station_organization_id"
          styled
          renderComponent={({ labelRender, goTo }) => (
            <ButtonSmallIcon
              iconType="building"
              label="Organisation: "
              onClick={() => goTo()}
            >
              {labelRender}
            </ButtonSmallIcon>
          )}
        />
      </div>

      <div style={{ height: 200, width: "100%", display: "flex", gap: 30 }}>
        <div style={{ flex: 1, height: "100%" }}>
          <SingleStation.Images style={{ height: 200 }} />
        </div>
        <div style={{ width: "40%", height: "100%" }}>
          <SingleStation.LocationMap />
        </div>
      </div>
      <div style={{ height: 50 }} />
      <div style={{ display: "flex", justifyContent: "space-between" }}>
      <SectionTitle iconSize={8} iconType={"info"}>Statistiques</SectionTitle>
      <SingleStation.Charts.FilterTimeWindowBtn  />
      </div>

         <div style={{ height: 30 }} />
      <div style={{ height: 200, width: "100%", display: "flex", gap: 30 }}>
        <div style={{ flex: 1, height: "100%", display: "flex", gap: 30 }}>
          <div style={{ height: "100%", width: "50%" }}>
            <TextBox
              content={[
                {
                  title: "Total kWh fournis en PayGo",
                  LeftIconRender: () => (
                    <JWayIcon color="gray" type="thunder" size={10} />
                  ),
                  TextRender: () => (
                    <p style={{ fontSize: "1.5rem", margin: 10 }}>
                      <SingleStation.NbKwhProvided />
                    </p>
                  ),
                },
                {
                  title: "Total Nb de sessions de recharge",
                  LeftIconRender: () => (
                    <JWayIcon color="gray" type="electricStation" size={12} />
                  ),
                  TextRender: () => (
                    <p style={{ fontSize: "1.5rem", margin: 10 }}>
                      <SingleStation.NbChargingSessionsProvided />
                    </p>
                  ),
                },
              ]}
            />
          </div>
          <div style={{ height: "100%", width: "50%" }}>
            <TextBox
              content={[
                {
                  title: "Montant total encaissé (FCFA)",
                  LeftIconRender: () => (
                    <JWayIcon color="gray" type="coin" size={15} />
                  ),
                  TextRender: () => (
                    <p style={{ fontSize: "1.5rem", margin: 10 }}>
                      <SingleStation.TotalMoney />
                    </p>
                  ),
                },
              ]}
            />
          </div>
        </div>

        <div style={{ width: "40%", height: "100%" }}></div>
      </div>
      <div style={{ height: 50 }} />
      
        <div style={{ width: "100%" }}>

          <TextBox
            content={[
              {
                title: "Énergie consommmée",
                isDrawable: true,
                LeftIconRender: () => (
                  <JWayIcon color="gray" type="thunder" size={10} />
                ),
                TextRender: () => <div style={{ width: "95%", marginLeft: "10px"}}><SingleStation.Charts.EnergyActive /></div>,
              },
            ]}
          />
        </div>
      
      <div style={{ height: 50 }} />
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <SectionTitle iconType={"thunder"}>Liste des bornes</SectionTitle>
        <SingleStation.AddNewChargeBtnModal />
      </div>
      <SingleConnectorModal zIndex={1001} />
      <SingleStation.CharePointList />
      <SingleChargePoint.ModalSingleChargePoint />
      <div style={{ height: 100, width: "100%" }} />
      <SectionTitle iconType={"plug-icon"}>Dernières recharges</SectionTitle>
      <SingleStation.ChargingSessionList pageSize={5} />
      <SingleChargingSessionPageDrawer />
      <EditConnectorPageDrawer zIndex={1002} />
    </PageContent>
  );
}
